import { cn } from '@lib/utils';
import * as React from 'react';
import { TooltipComponent } from '../core/tooltip.component';

type FormLabelProps = {
  className?: string;
  htmlFor?: string;
  isRequired?: boolean;
  label: string;
  ref?: React.Ref<HTMLLabelElement>;
  tooltip?: React.ReactNode;
};

export const FormLabel = (props: FormLabelProps) => {
  const { className = '', htmlFor, isRequired = false, label, ref, tooltip } = props;

  const labelContent = (
    <label
      className={cn('font-medium leading-5 text-sm text-gray-700 justify-start inline-flex', className)}
      htmlFor={htmlFor}
      ref={ref}
    >
      {isRequired && <span className="text-red-500 mr-0.5">*</span>}
      {label}
    </label>
  );

  if (tooltip) {
    return (
      <div className="flex items-center gap-1 w-auto">
        {labelContent}
        <TooltipComponent
          className="text-xs whitespace-pre-wrap"
          side="right"
          triggerClassName="text-gray-500 bg-white"
        >
          {tooltip}
        </TooltipComponent>
      </div>
    );
  }

  return labelContent;
};

FormLabel.displayName = 'FormLabel';
